<script setup lang="ts">
import { computed } from 'vue';
import GaiaAvatar from '../../base/GaiaAvatar.vue';
import GaiaText from '../../base/GaiaText.vue';
import { gaiaNeutral, gaiaTracking } from '../../themes/tokens';

const props = defineProps({
  /** Workspace/organization name. */
  name: {
    type: String,
    required: true,
  },
});

const initial = computed(() => props.name.trim().charAt(0).toUpperCase());

const faint = gaiaNeutral.textFaint;
const hoverWash = gaiaNeutral.surfaceHover;
const displayTracking = gaiaTracking.display;
</script>

<template>
  <div class="gaia-workspace-switcher">
    <slot name="mark">
      <gaia-avatar variant="mark">{{ initial }}</gaia-avatar>
    </slot>
    <!-- Keeps its .name class: GaiaSidebar hides it in the collapsed rail via
         :deep(.gaia-workspace-switcher .name). -->
    <gaia-text class="name" weight="bold" tone="ink" :style="{ letterSpacing: displayTracking }">
      {{ props.name }}
    </gaia-text>
    <svg
      class="chevrons"
      width="12"
      height="12"
      viewBox="0 0 12 12"
      fill="none"
      :stroke="faint"
      stroke-width="1.4"
      stroke-linecap="round"
    >
      <path d="M3.5 4.5 6 2l2.5 2.5M3.5 7.5 6 10l2.5-2.5" />
    </svg>
  </div>
</template>

<style scoped>
/* Sidebar workspace row from mock 5a — a bespoke clickable row (naive has no
   equivalent); typography and washes come from the shared tokens. */
.gaia-workspace-switcher {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 4px 2px;
  border-radius: 8px;
  cursor: pointer;
}

.gaia-workspace-switcher:hover {
  background: v-bind(hoverWash);
}

/* Stays CSS rather than becoming `<gaia-text truncate>`: GaiaSidebar hides this
   in the collapsed rail via :deep(.gaia-workspace-switcher .name){display:none},
   and the prop sets `display: block` inline, which would out-rank that. */
.name {
  min-width: 0;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.chevrons {
  margin-left: auto;
  flex: none;
}
</style>
